import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/retirement-longevity-calculator',
  component: () => import('../../routes/RetirementLongevityCalculator.svelte'),
  card: {
    id: 'retirement-longevity',
    title: 'Retirement Longevity',
    description: 'Will your savings outlast you? Run Monte Carlo simulations to estimate the probability of outliving your retirement portfolio.',
    icon: 'elderly',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/retirement-longevity-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Retirement Longevity Calculator – Will Your Savings Last?',
    description: 'Free retirement longevity calculator using Monte Carlo simulation. See the probability of outliving your savings based on withdrawal rate, Social Security, and portfolio returns. Plan smarter for a secure retirement.',
  },
};

export default meta;